import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { get } from './api';
export type Branding={orgName:string;logoUrl:string|null;defaultCountry:string;primaryLight?:string;primaryDark?:string;iconVersion?:string|null};
export function useBranding() {
  return useQuery({queryKey:['branding'],queryFn:()=>get<Branding>('/api/public/branding'),staleTime:30_000});
}
function tint(hex:string,white:boolean) {
  return '#'+[1,3,5].map(i=>Math.round(parseInt(hex.slice(i,i+2),16)*.25+(white?255*.75:0)).toString(16).padStart(2,'0')).join('');
}
/** Only public, AA-validated colour settings. Text variants stay high contrast on existing soft fills. */
export function BrandingBridge() {
  const {data}=useBranding();
  useEffect(()=>{
    if(!data)return;
    document.title=data.orgName;
    let style=document.getElementById('wd-brand-colors');
    if(!style){style=document.createElement('style');style.id='wd-brand-colors';document.head.append(style);}
    const light=data.primaryLight,dark=data.primaryDark;
    style.textContent=light&&dark&&/^#[0-9a-f]{6}$/i.test(light)&&/^#[0-9a-f]{6}$/i.test(dark)
      ?`:root{--color-primary:${light};--color-primary-text:${light==='#2b48d4'?'#1c318f':tint(light,false)}}:root.dark{--color-primary:${dark};--color-primary-text:${dark==='#4361e8'?'#a9b7f5':tint(dark,true)}}`:'';
    const apple=document.querySelector('link[rel="apple-touch-icon"]');
    apple?.setAttribute('href',data.iconVersion?`/branding/icons/180.png?v=${data.iconVersion}`:'/icons/apple-touch-icon.png');
  },[data]);
  return null;
}
